export const WIDGET_SDK_MESSAGE_SOURCE = 'vipps-widget-sdk';

export interface IframeAdapter {
  isEmbedded(): boolean;
  isWidgetSdkEmbed(): boolean;
  postToParent(message: string | Record<string, unknown>): void;
  observeResize(element: HTMLElement, onResize: () => void): () => void;
}
